var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetricinfoLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 70,
    viewBox: "0 0 200 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.72 20.3114C26.5299 16.363 26.3019 11.5794 26.3399 7.44122H26.2258C25.1996 11.1618 23.9453 15.3 22.577 19.1725L18.13 32.4603H13.7591L9.65415 19.3623C8.47589 15.4519 7.37364 11.2757 6.53746 7.44122H6.46144C6.34741 11.4276 6.15737 16.2871 5.92932 20.5012L5.24517 32.8399H0L2.05246 2.16406H9.4261L13.455 14.5027C14.5572 18.1094 15.5075 21.7541 16.2676 25.171H16.4197C17.2558 21.83 18.2821 18.0715 19.4603 14.4648L23.7173 2.16406H31.0149L32.8013 32.8399H27.2901L26.72 20.3114Z",
    fill: "url(#paint0_linear_7734_8225)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4564 23.3108C42.6084 27.3351 45.7251 29.0435 49.2979 29.0435C51.8825 29.0435 53.7829 28.6638 55.4553 28.0564L56.2914 31.9288C54.391 32.6882 51.7304 33.2956 48.5377 33.2956C41.3541 33.2956 37.0972 28.8916 37.0972 22.0959C37.0972 15.9455 40.822 10.1748 47.9296 10.1748C55.1132 10.1748 57.5077 16.0974 57.5077 20.9569C57.5077 22.0199 57.4317 22.8172 57.3177 23.3108H42.4564ZM52.2245 19.4003C52.2625 17.3502 51.3503 13.9713 47.6255 13.9713C44.1667 13.9713 42.6844 17.1224 42.4564 19.4003H52.2245Z",
    fill: "#5F439B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4523 4.32715V10.6673H73.7735V14.8435H68.4523V24.6385C68.4523 27.334 69.1745 28.7388 71.341 28.7388C72.2912 28.7388 73.0133 28.5869 73.5454 28.473L73.6215 32.7631C72.7853 33.0668 71.341 33.2946 69.5546 33.2946C67.5021 33.2946 65.7537 32.6112 64.7275 31.4722C63.5492 30.1814 62.9791 28.2072 62.9791 25.2839V14.8435H59.7864V10.6673H62.9791V5.65593L68.4523 4.32715Z",
    fill: "#5F439B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0336 17.8058C78.0336 14.8066 77.9955 12.6425 77.8435 10.6684H82.7086L82.8986 14.9205H83.0887C84.1909 11.7693 86.7755 10.1748 89.132 10.1748C89.6641 10.1748 90.0062 10.2128 90.4623 10.3267V15.5659C90.0062 15.4899 89.5121 15.376 88.828 15.376C86.1294 15.376 84.3049 17.1224 83.8108 19.6281C83.7348 20.1217 83.6208 20.7291 83.6208 21.3745V32.84H78.0336V17.8058Z",
    fill: "#5F439B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.226 4.47941C100.226 6.14988 99.0099 7.47866 97.0334 7.47866C95.171 7.47866 93.9167 6.14988 93.9167 4.47941C93.9167 2.73302 95.171 1.4422 97.0715 1.4422C99.0099 1.40423 100.188 2.73302 100.226 4.47941ZM94.2588 32.8394V10.6677H99.9221V32.8394H94.2588Z",
    fill: "#5F439B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122.275 32.1566C121.097 32.6882 118.779 33.2956 115.966 33.2956C109.048 33.2956 104.525 28.8916 104.525 22.0199C104.525 15.376 109.086 10.1748 116.878 10.1748C118.931 10.1748 121.021 10.6304 122.313 11.2378L121.325 15.414C120.413 14.9964 119.083 14.5408 117.068 14.5408C112.773 14.5408 110.227 17.6919 110.265 21.7162C110.265 26.272 113.229 28.8537 117.068 28.8537C119.045 28.8537 120.413 28.4361 121.477 27.9805L122.275 32.1566Z",
    fill: "#5F439B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M132.268 2.12598V32.8018H126.643V2.12598H132.268Z",
    fill: "url(#paint1_linear_7734_8225)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M138.733 17.2743C138.733 14.7306 138.695 12.5666 138.543 10.6684H143.484L143.75 14.0093H143.902C144.852 12.2629 147.285 10.1748 150.971 10.1748C154.848 10.1748 158.877 12.6805 158.877 19.7041V32.878H153.252V20.3495C153.252 17.1604 152.074 14.7306 148.995 14.7306C146.753 14.7306 145.194 16.3252 144.624 17.9956C144.434 18.4892 144.396 19.1726 144.396 19.818V32.84H138.733V17.2743Z",
    fill: "url(#paint2_linear_7734_8225)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M165.452 32.8399V14.8444H162.449V10.6682H165.452V9.68112C165.452 6.79577 166.212 3.94838 168.15 2.12605C169.785 0.607443 172.027 0 173.966 0C175.486 0 176.664 0.227791 177.576 0.531513L177.12 4.85954C176.512 4.63175 175.752 4.44193 174.764 4.44193C171.989 4.47989 171.039 6.79577 171.039 9.52926V10.6682H175.904V14.8444H171.077V32.8399H165.452Z",
    fill: "url(#paint3_linear_7734_8225)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M200 21.5266C200 29.6891 194.261 33.3338 188.598 33.3338C182.327 33.3338 177.461 29.0058 177.461 21.9063C177.461 14.617 182.25 10.175 188.94 10.175C195.553 10.1371 200 14.8068 200 21.5266ZM183.239 21.7544C183.239 26.0445 185.329 29.2715 188.75 29.2715C191.943 29.2715 194.185 26.1204 194.185 21.6785C194.185 18.2237 192.627 14.2373 188.788 14.2373C184.835 14.2373 183.239 18.0718 183.239 21.7544Z",
    fill: "url(#paint4_linear_7734_8225)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M120.239 46.4201L119.567 50.2211H124.502L124.103 52.4891H119.168L118.475 56.4581H124.04L123.62 58.7891H115.094L117.698 44.1101H126.203L125.804 46.4201H120.239ZM144.856 44.1311L142.273 58.7891H139.312L140.992 49.2971L135.406 58.7891H133.159L130.912 49.2761L129.232 58.7891H126.271L128.875 44.1311H132.214L134.965 55.0091L141.517 44.1311H144.856ZM150.724 58.9361C149.254 58.9361 148.043 58.6071 147.091 57.9491C146.153 57.2771 145.684 56.3391 145.684 55.1351C145.684 55.0091 145.698 54.8201 145.726 54.5681H148.729C148.673 55.1561 148.827 55.6391 149.191 56.0171C149.569 56.3951 150.115 56.5841 150.829 56.5841C151.543 56.5841 152.103 56.4371 152.509 56.1431C152.929 55.8351 153.139 55.4011 153.139 54.8411C153.139 54.3231 152.922 53.9101 152.488 53.6021C152.068 53.2941 151.403 52.9511 150.493 52.5731C149.653 52.2231 148.967 51.9011 148.435 51.6071C147.917 51.3131 147.469 50.9071 147.091 50.3891C146.727 49.8571 146.545 49.1921 146.545 48.3941C146.545 47.4841 146.776 46.6931 147.238 46.0211C147.714 45.3491 148.358 44.8311 149.17 44.4671C149.996 44.1031 150.934 43.9211 151.984 43.9211C153.02 43.9211 153.916 44.0961 154.672 44.4461C155.442 44.7821 156.016 45.2651 156.394 45.8951C156.786 46.5251 156.954 47.2601 156.898 48.1001H153.769L153.79 47.8691C153.79 47.4071 153.615 47.0291 153.265 46.7351C152.929 46.4411 152.453 46.2941 151.837 46.2941C151.179 46.2941 150.647 46.4481 150.241 46.7561C149.835 47.0641 149.632 47.4841 149.632 48.0161C149.632 48.3661 149.744 48.6741 149.968 48.9401C150.206 49.1921 150.493 49.4161 150.829 49.6121C151.165 49.7941 151.648 50.0321 152.278 50.3261C153.104 50.6901 153.783 51.0331 154.315 51.3551C154.847 51.6771 155.302 52.1041 155.68 52.6361C156.058 53.1681 156.247 53.8191 156.247 54.5891C156.247 55.4291 156.016 56.1781 155.554 56.8361C155.106 57.4941 154.462 58.0121 153.622 58.3901C152.796 58.7541 151.83 58.9361 150.724 58.9361ZM164.918 55.3871C166.472 54.2531 167.69 53.3291 168.572 52.6151C169.468 51.8871 170.238 51.1381 170.882 50.3681C171.54 49.5981 171.932 48.8491 172.058 48.1211C172.1 47.9111 172.121 47.7081 172.121 47.5121C172.121 47.0081 171.974 46.6161 171.68 46.3361C171.4 46.0561 170.966 45.9161 170.378 45.9161C169.692 45.9161 169.125 46.1471 168.677 46.6091C168.229 47.0571 167.914 47.7011 167.732 48.5411H164.897C165.233 46.8611 165.954 45.5871 167.06 44.7191C168.166 43.8511 169.447 43.4171 170.903 43.4171C172.289 43.4171 173.339 43.7461 174.053 44.4041C174.767 45.0481 175.124 45.9091 175.124 46.9871C175.124 47.3371 175.096 47.6521 175.04 47.9321C174.858 48.9821 174.389 49.9901 173.633 50.9561C172.877 51.9221 172.058 52.7761 171.176 53.5181C170.294 54.2461 169.153 55.1211 167.753 56.1431H173.948L173.507 58.5791H163.154L163.532 56.3951L164.918 55.3871ZM176.935 58.9361C176.473 58.9361 176.102 58.8031 175.822 58.5371C175.542 58.2711 175.402 57.9351 175.402 57.5291C175.402 56.9691 175.612 56.4931 176.032 56.1011C176.466 55.6951 176.97 55.4921 177.544 55.4921C178.006 55.4921 178.37 55.6251 178.636 55.8911C178.916 56.1431 179.056 56.4791 179.056 56.8991C179.056 57.4591 178.846 57.9421 178.426 58.3481C178.006 58.7401 177.509 58.9361 176.935 58.9361ZM182.138 51.1241C182.558 48.7721 183.321 46.9171 184.427 45.5591C185.547 44.2011 187.122 43.5221 189.152 43.5221C192.204 43.5221 193.73 45.1741 193.73 48.4781C193.73 49.3181 193.646 50.2001 193.478 51.1241C192.582 56.2061 190.244 58.7471 186.464 58.7471C183.412 58.7471 181.886 57.0881 181.886 53.7701C181.886 52.9301 181.97 52.0481 182.138 51.1241ZM190.58 51.1241C190.748 50.1861 190.832 49.4091 190.832 48.7931C190.832 47.9951 190.664 47.3721 190.328 46.9241C190.006 46.4761 189.453 46.2521 188.669 46.2521C187.549 46.2521 186.73 46.6791 186.212 47.5331C185.694 48.3871 185.302 49.5841 185.036 51.1241C184.868 52.0621 184.784 52.8391 184.784 53.4551C184.784 54.2671 184.945 54.8971 185.267 55.3451C185.603 55.7931 186.163 56.0171 186.947 56.0171C187.731 56.0171 188.361 55.8001 188.837 55.3661C189.313 54.9321 189.677 54.3721 189.929 53.6861C190.181 52.9861 190.398 52.1321 190.58 51.1241Z",
    fill: "#F38280"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7734_8225",
    x1: -0.622579,
    y1: 17.4849,
    x2: 197.301,
    y2: 17.4849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#542E90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0674,
    stopColor: "#563292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1399,
    stopColor: "#5D3F99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2146,
    stopColor: "#6755A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2685,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2876,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5197,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7266,
    stopColor: "#845BA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F38280"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7734_8225",
    x1: -0.623695,
    y1: 17.4848,
    x2: 197.3,
    y2: 17.4848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#542E90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0674,
    stopColor: "#563292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1399,
    stopColor: "#5D3F99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2146,
    stopColor: "#6755A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2685,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2876,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5197,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7266,
    stopColor: "#845BA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F38280"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7734_8225",
    x1: -0.620699,
    y1: 21.4926,
    x2: 197.303,
    y2: 21.4926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#542E90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0674,
    stopColor: "#563292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1399,
    stopColor: "#5D3F99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2146,
    stopColor: "#6755A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2685,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2876,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5197,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7266,
    stopColor: "#845BA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F38280"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7734_8225",
    x1: -0.621796,
    y1: 16.415,
    x2: 197.302,
    y2: 16.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#542E90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0674,
    stopColor: "#563292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1399,
    stopColor: "#5D3F99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2146,
    stopColor: "#6755A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2685,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2876,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5197,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7266,
    stopColor: "#845BA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F38280"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7734_8225",
    x1: -0.622696,
    y1: 21.7434,
    x2: 197.301,
    y2: 21.7434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#542E90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0674,
    stopColor: "#563292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1399,
    stopColor: "#5D3F99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2146,
    stopColor: "#6755A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2685,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2876,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5197,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7266,
    stopColor: "#845BA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F38280"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricinfoLog);
export default __webpack_public_path__ + "static/media/metricinfo-log.8536744948d06187b50aa1e4eceec69a.svg";
export { ForwardRef as ReactComponent };